/*************************************************************************
 *
 * KLEARNOW CONFIDENTIAL
 * __________________
 *
 *  Copyright (c) 2018 - 2020 KLEARNOW Corporation.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of KLEARNOW Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to KLEARNOW Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from KLEARNOW Corporation.
 */

// import * as actions from '../actions/initializeValues';
// import { demoShipments } from '../util/demoShipments'
// import { dummyDataContainerInfo, coors } from '../util/testJSON'
// import { shipmentListData, shipmentActivityDetail, shipmentsCurrentLocation } from '../data/shipmentData'
import {
  saveActorName,
  saveActorAddress,
  saveImporterField,
  saveImporterAddressAndName,
  saveImporterName,
  saveImporterNo,
  saveConsigneeAddress,
  saveConsigneeName,
  saveConsigneeNo,
} from "../api/setFormData";

const initialState = {
  // initialValues
};

export default function ImporterReducer(state = initialState, action) {
  switch (action.type) {
    case "INITIALIZE_VALUES_IMPORTER": {
      return Object.assign({}, state, { ...action.payload });
    }
    case "UPDATE_ACTOR_FIELD": {
      let newActor = Object.assign({}, state[action.actor]);
      newActor[action.field] = action.payload;
      return Object.assign({}, state, { [action.actor]: newActor });
    }
    case "UPDATE_ACTOR_ADDRESS": {
      let newActor = Object.assign({}, state[action.actor]);
      newActor.addressInfo[action.field] = action.payload;
      return Object.assign({}, state, { [action.actor]: newActor });
    }
    case "UPDATE_HEADER_PARTY_FIELD": {
      let headerParties = state.headerParties.slice();
      headerParties[action.headerPartyIndex][action.field] = action.payload;
      return Object.assign({}, state, { headerParties });
    }
    case "UPDATE_HEADER_PARTY": {
      let headerParties = state.headerParties.slice();
      if (action.sameAs === "Importer") {
        headerParties[action.headerPartyIndex].name = state.importer.name;
        headerParties[action.headerPartyIndex].addressInfo =
          state.importer.addressInfo;
      } else {
        const reqParty = headerParties.find(
          (party) =>
            party.headerPartyType.toLowerCase() === action.sameAs.toLowerCase()
        );
        headerParties[action.headerPartyIndex].name = reqParty.name;
        headerParties[action.headerPartyIndex].addressInfo =
          reqParty.addressInfo;
      }
      return Object.assign({}, state, { headerParties });
    }
    case "UPDATE_HEADER_PARTY_ADDRESS": {
      let headerParties = state.headerParties.slice();
      headerParties[action.headerPartyIndex].addressInfo[action.field] =
        action.payload;
      return Object.assign({}, state, { headerParties });
    }
    case "ADD_HEADER_PARTY": {
      let newHeaderParty = {
        headerPartyType: "",
        name: "",
        addressInfo: {
          STREET_NAME: "",
          CITY: "",
          COUNTRY_SUB_ENTITY: "",
          POSTAL_CODE: "",
          COUNTRY: "",
          COUNTRY_CODE: "",
        },
        headerId: "",
      };
      let headerParties = state.headerParties.slice();
      headerParties.push(newHeaderParty);
      return Object.assign({}, state, { headerParties });
    }

    case "ADD_MANUFACTURER": {
      let newHeaderParties = state.headerParties.slice();
      newHeaderParties.push(action.newManufacturer);
      return Object.assign({}, state, { headerParties: newHeaderParties });
    }

    case "UPDATE_FIELD": {
      return Object.assign({}, state, { [action.field]: action.payload });
    }

    // Save Data
    case "SAVE_IMPORTER_NAME": {
      saveImporterName(state.importer.name, state.importer.importerId);
      return state;
    }

    case "SAVE_IMPORTER_NUMBER": {
      let no = state.importer.importerNo || "_BLANK_";
      saveImporterNo(no, state.importer.importerId);
      return state;
    }
    // Save Data
    case "SAVE_IMPORTER": {
      saveImporterAddressAndName(
        state.importer.name,
        state.importer.addressInfo,
        state.importer.importerId
      );
      return state;
    }
    // Save Data
    case "SAVE_CONSIGNEE_NAME": {
      saveConsigneeName(state.consignee.name, state.consignee.consigneeId);
      return state;
    }

    case "SAVE_CONSIGNEE_NUMBER": {
      let no = state.consignee.consigneeNo || "_BLANK_";
      saveConsigneeNo(no, state.consignee.consigneeId);
      return state;
    }
    case "SAVE_CONSIGNEE": {
      saveConsigneeAddress(
        state.consignee.addressInfo,
        state.consignee.consigneeId
      );
      return state;
    }
    case "INITIALIZE_SHIPID": {
      return Object.assign({}, state, { shipId: action.payload });
    }
    default:
      return state;
  }
}
